import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { HBox } from '../../../components/Box';
import { selectInvoiceFilter } from '../selectors';
import { CompanySelection } from '../../Companies/components/CompanySelection';
import { changeInvoiceFilter } from '../actions';
import { Times } from '../../../components/Icon';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './CompanySearch.module.css';

const Container = styled.div`
  .box.company {
    white-space: nowrap;
  }
`;

const STATE = {
  select: false,
};
/* eslint-disable react/prefer-stateless-function */
class InvoiceCompanySearchComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    if (!this.props.filter) return null;
    if (this.props.filter.company) {
      return (
        <div className="d-flex">
          <input
            disabled
            type="text"
            className={`form-control fw-light ${styles.Input}`}
            value={this.props.filter.company.name}
          />
          <button
            className={`btn btn-outline-secondary ${styles.Button}`}
            type="button"
            onClick={() => {
              this.props.onSelect(null);
            }}
          >
            <Times />
          </button>
        </div>
      );
    }
    return (
      <Container>
        <HBox vCenter>
          {!this.props.filter.company ? (
            <ButtonComponent style={'ButtonSoftPrimaryFullWidth'} onClick={this.setStateFn({ select: true })}>
              {this.lbl('invoice.search.company')}
            </ButtonComponent>
          ) : null}
        </HBox>
        {this.state.select ? (
          <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('invoice.search.company')}>
            <CompanySelection onSelect={this.props.onSelect} />
          </ModalComponent>
        ) : null}
      </Container>
    );
  }
}

InvoiceCompanySearchComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectInvoiceFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    onSelect(company) {
      dispatch(changeInvoiceFilter('company', company));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoiceCompanySearch = compose(withConnect, withRouter)(InvoiceCompanySearchComp);
